"use client"

import { useState } from "react"
import { Check, Copy } from "lucide-react"
import { CONNECTOR_URL } from "@/lib/connector"

/** The connector address with a copy button, as people paste it into Claude. */
export function CopyConnectorUrl({
  label = "Connector URL",
  words = { copy: "Copy", copied: "Copied" },
}: {
  label?: string
  words?: { copy: string; copied: string }
}) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    try {
      await navigator.clipboard.writeText(CONNECTOR_URL)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard can be blocked; the address stays selectable either way.
    }
  }

  return (
    <div className="mt-3 overflow-hidden rounded-lg border border-border bg-[#0f1219] text-[#fafafa]">
      <div className="flex items-center justify-between border-b border-white/10 px-3 py-2">
        <span className="text-xs font-medium uppercase tracking-wide text-white/60">{label}</span>
        <button
          type="button"
          onClick={copy}
          className="inline-flex items-center gap-1.5 rounded-md bg-white/10 px-2.5 py-1 text-xs font-medium hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-daash-red/60"
        >
          {copied ? <Check className="size-3.5" aria-hidden /> : <Copy className="size-3.5" aria-hidden />}
          {copied ? words.copied : words.copy}
        </button>
      </div>
      <pre className="overflow-x-auto px-3 py-3 font-mono text-sm">
        <code>{CONNECTOR_URL}</code>
      </pre>
    </div>
  )
}
